'use strict';
var twentyninetimes = twentyninetimes || {};

twentyninetimes.sliders = twentyninetimes.sliders || function () {

	function init() {
		pricing_table();
	}

	function pricing_table() {
        var pricing_table = document.querySelector('.js-block-pricing');
        if ( pricing_table && window.innerWidth <= 991 ) {
            var flkty = new Flickity( pricing_table, {
                pageDots: false,
                prevNextButtons: false,
                draggable: '>1',
            });
        }
    }

	return {
		init : init
	};

}();